import { render } from "./UnitDataManager.vue?vue&type=template&id=7b5ab70a&scoped=true"
import script from "./UnitDataManager.vue?vue&type=script&lang=js"
export * from "./UnitDataManager.vue?vue&type=script&lang=js"

import "./UnitDataManager.vue?vue&type=style&index=0&id=7b5ab70a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5ab70a"]])

export default __exports__